import React from "react";
import "./PhoneModal.css";

const PhoneModal = ({ isOpen, onClose }) => {
  const phoneNumber = "514-279-7209";
  const phoneLink = `tel:${phoneNumber.replace(/[^0-9]/g, "")}`;

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="phoneModal__backdrop" onClick={onClose} />
      
      {/* Modal */}
      <div className="phoneModal__container" role="dialog" aria-labelledby="phone-modal-title" aria-modal="true">
        <button 
          className="phoneModal__close" 
          onClick={onClose}
          aria-label="Close modal"
        >
          ✕
        </button>
        
        <div className="phoneModal__content">
          <h2 id="phone-modal-title" className="phoneModal__title">
            📞 Give Us A Call
          </h2>
          
          <p className="phoneModal__description">
            Call us now to discuss your security needs and get expert advice from our team.
          </p>
          
          <div className="phoneModal__phoneBox">
            <span className="phoneModal__phoneLabel">Office Number:</span>
            <a href={phoneLink} className="phoneModal__phoneNumber">
              {phoneNumber}
            </a>
          </div>
          
          <div className="phoneModal__actions">
            <a href={phoneLink} className="phoneModal__callButton">
              📱 Call Now
            </a>
            <button onClick={onClose} className="phoneModal__cancelButton">
              Close
            </button>
          </div>
          
          <p className="phoneModal__hours">
            <strong>Business Hours:</strong><br />
            Monday - Friday: 9:00 AM - 6:00 PM<br />
            Saturday - Sunday: 10:00 AM - 6:00 PM
          </p>
        </div>
      </div>
    </>
  );
};

export default PhoneModal;
// Likely will have to add an Api that connect with the phone number of the user so that they could call.//